import { Component } from '@angular/core';

@Component({
  selector: 'app-ias-loader',
  standalone: true,
  imports: [],
  templateUrl: './ias-loader.component.html',
  styleUrl: './ias-loader.component.scss'
})
export class IasLoaderComponent {

}
